import { Container } from '@mui/material';
import React, { Component } from 'react'
import { Redirect } from 'react-router-dom';
import Constantes from '../php/Constantes'

class CambioContrassenia extends Component {
    constructor(props){
        super(props);
        this.state = {
            cambio: {
                numeroFuncionario: '',
                password: '',
                nombreFuncionario: '',
                passwordConfirmada: '',
            },
            notificaciones: null,
            errores: null,
            numeroNombre: [],
        }
        this.controlarCambios = this.controlarCambios.bind(this);
        this.manejarEnvioDatos = this.manejarEnvioDatos.bind(this);
    }

    async componentDidMount(){
        const numNom = await fetch(`${Constantes.RUTA_API}/obtener_numerosNombre.php`);
        const datosNumNom = await numNom.json();
        this.setState({
            numeroNombre: datosNumNom,
        });
    }

    render(){
        return (
            <>
                <Container>
                    {sessionStorage.login && sessionStorage.tipoUsuario === '1'
                    ?
                        <div className='mt-5'>
                            <h3 className='text-center'>REGISTRO</h3>
                            <hr />
                            <div className='row justify-content-center'>
                                <div className="col-12 col-sm-8 col-md-6 col-xl-4">
                                    <form onSubmit={this.manejarEnvioDatos}>
                                        {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                                        {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                                        <input type="text" className='form-control mb-2'  placeholder='INGRESE NUMERO DE FUNCIONARIO' id='numeroFuncionario' onChange={this.controlarCambios} value={this.state.cambio.numeroFuncionario}/>
                                        <input type="password" className='form-control mb-2' placeholder='INGRESE NUEVA CONTRASEÑA' id='password' onChange={this.controlarCambios} value={this.state.cambio.password}/>
                                        <input type="password" className='form-control mb-2' placeholder='CONFIRMAR NUEVA CONTRASEÑA' id='passwordConfirmada' onChange={this.controlarCambios} value={this.state.cambio.passwordConfirmada}/>
                                        <button className='btn btn-outline-dark btn-lg btn-block'>CONFIRMAR</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    :
                        <Redirect to='/inicio'/>
                    }
                </Container>
            </>
        )//Final Return
    }//Final Render

    controlarCambios(e){
        e.preventDefault()
        this.setState({
            errores: null,
            notificaciones: null,
        })
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const registroActualizado = state.cambio;
            registroActualizado[clave] = valor;
            if((clave === 'numeroFuncionario') && (valor !== '')){
                //valor = parseFloat(valor);
                //Tengo que buscar la informacion de ese funcionario
                let aux = true;
                this.state.numeroNombre.map((name) =>
                {if(name.numeroFuncionario === valor){
                    registroActualizado['nombreFuncionario'] = name.primerNombre + ' ' + name.primerApellido;
                    aux = false;
                }else if(aux){
                    registroActualizado['nombreFuncionario'] = '';
                }
                });
            }else if((clave === 'numeroFuncionario') && (valor === '')){
                registroActualizado['nombreFuncionario'] = '';
            }
            
            return{
                registro: registroActualizado,
            };
        })
    }

    async manejarEnvioDatos(e){
        e.preventDefault();
        if(this.state.cambio.numeroFuncionario === ''){
            this.setState({
                errores: 'Debe ingresar un número de funcionario!'
            });
        }else if((this.state.cambio.numeroFuncionario !== '') && (this.state.cambio.nombreFuncionario === '') && (sessionStorage.tipoUsuario === '2')){
            this.setState({
                errores: 'Debe ingresar un número de funcionario valido!'
            });
        }else if(this.state.cambio.password === ''){
            this.setState({
                errores: 'Debe ingresar la nueva contraseña!'
            });
        }else if(this.state.cambio.passwordConfirmada === ''){
            this.setState({
                errores: 'Debe confirmar la nueva contraseña!'
            });
        }else if(this.state.cambio.passwordConfirmada !== this.state.cambio.password){
            this.setState({
                errores: 'Las contraseñas deben coincidir!'
            });
        }else{
            const cargaUtil = JSON.stringify(this.state.cambio);

            const respuesta = await fetch(`${Constantes.RUTA_API}/cambio_contrasenia.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await respuesta.json();

            if(exito.length !== 0){
                this.setState({
                    notificaciones: 'La contraseña fue actualizada correctamente!',
                    cambio: {
                        numeroFuncionario: '',
                        password: '',
                        nombreFuncionario: '',
                        passwordConfirmada: '',
                    },
                })
            }else{
                this.setState({
                    errores: 'La contraseña no fue actualizada!',
                })
            }
        }
    }
}

export default CambioContrassenia